import type { FC } from 'react';
import { Button } from '@ordr-as/umami-react/button';
import { useLocation } from '../../context/LocationContext';
import { useTotalPrice } from '../../hooks/useTotalPrice';
import { useTotalCartQuantity } from '../../context/cart/useCartHelpers';

interface Props {
  onClick: () => void;
}

const CartButton: FC<Props> = ({ onClick }) => {
  const { formatCurrency } = useLocation();
  const totalQuantity = useTotalCartQuantity();
  const totalPrice = useTotalPrice();

  if (totalQuantity < 1) {
    return null;
  }

  return (
    <>
      <div className="h-8" />
      <article className="fixed inset-x-0 bottom-0 max-w-[500px] mx-auto p-4 bg-brand-white border-y border-grey-lightest">
        <Button className="grid grid-cols-3" kind="primary" fullWidth onClick={onClick}>
          <div className="w-[22px] h-[22px] flex justify-center items-center bg-brand-primary rounded text-extra-small">
            {totalQuantity}
          </div>
          <div>Cart</div>
          <div className="text-bold text-right">{formatCurrency(totalPrice)}</div>
        </Button>
      </article>
    </>
  );
};

export default CartButton;
